import {Component, input} from '@angular/core';
import {NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'attachment-card',
  imports: [
    NgOptimizedImage
  ],
  templateUrl: './attachment-card.component.html',
})
export class AttachmentCardComponent {
  attachment = input.required<any>();
  idPostfix = input<string>('');

  extractFileName(path: string): any {
    const fileNameWithExtension: string = path.split('/').pop() || '';
    const lastDotIndex: number = fileNameWithExtension.lastIndexOf('.');
    return fileNameWithExtension.substring(0, lastDotIndex);
  }

  extractExtension(path: string): any {
    const fileNameWithExtension: string = path.split('/').pop() || '';
    const lastDotIndex: number = fileNameWithExtension.lastIndexOf('.');
    return fileNameWithExtension.substring(lastDotIndex + 1);
  }

  isImage(path: string) {
    const formats = ["jpg", "jpeg", "gif", "png", "webp", "tiff", "bmp", "svg"];
    return formats.indexOf(this.extractExtension(path)) >= 0;
  };

  handleImageClick(file_url: any) {
    window.open(file_url);
  }

  handleImageError(event: any): void {
    event.target.src = '../../../assets/icons/placeholder-image.png';
  }
}
